import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SnCamerasAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-camera-report-dialog',
  templateUrl: './camera-report-dialog.component.html',
  styleUrls: ['./camera-report-dialog.component.scss'],
})
export class CameraReportDialogComponent implements OnDestroy, OnInit {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'description',
      type: 'textarea',
      templateOptions: {
        label: t('map.camera.reportDialog.enterIssue'),
        autosize: true,
        appearance: 'outline',
      },
    },
  ];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public cameraId: string,
    private readonly _dialogRef: MatDialogRef<CameraReportDialogComponent>,
    private readonly _camerasApi: SnCamerasAPI,
  ) {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public submitForm(): void {
    this._camerasApi
      .reportIssue(this.cameraId, this.formModel)
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this._dialogRef.close();
      });
  }
}
